import React, { useRef } from 'react';
import { ContextMenu, ContextMenuTrigger, MenuItem, SubMenu } from 'react-contextmenu';
import { Dropdown } from 'react-bootstrap';
import { useAbility } from '@casl/react';
import BasicDropdown from '../Utils/Dropdown';
import Icon from '../Icons';
import { AbilityContext } from '../../config/abilityContext';
import { useDirectoryNodes } from './DirectoryNodesContext';

const DocumentActionButtons = ({
  permitedActions,
  item,
  handleButtonClick,
  parentId,
  canMoveFile,
  directoryNodes,
  handleMoveDocument
}) => {
  const ability = useAbility(AbilityContext);
  const { rrhh } = useDirectoryNodes();
  const dropDownItems = [];
  const contextTrigger = useRef(null);
  const toggleMenu = e => {
    if (contextTrigger.current) {
      contextTrigger.current.handleContextClick(e);
    }
  };

  if (permitedActions.find(e => e === 'show')) {
    dropDownItems.push({
      key: 'show',
      icon: <Icon icon="eye" height="16px" width="16px" style={{ marginRight: 5 }} />,
      title: 'Ver',
      props: {
        onClick: () => handleButtonClick(item, 'show', parentId)
      }
    });
    dropDownItems.push({
      key: 'download',
      icon: <Icon icon="download-2" height="16px" width="16px" style={{ marginRight: 5 }} />,
      title: 'Descargar',
      props: {
        onClick: () => handleButtonClick(item, 'download', parentId)
      }
    });
  }

  if (permitedActions.find(e => e === 'remove') && rrhh) {
    dropDownItems.push({
      key: 'trash',
      icon: <Icon icon="trash" height="16px" width="16px" style={{ marginRight: 5 }} />,
      title: 'Eliminar',
      props: {
        onClick: () => handleButtonClick(item, 'remove', parentId)
      }
    });
  }

  if (ability.can('show', 'WorkflowRequest') && permitedActions.find(e => e === 'show')) {
    dropDownItems.push({
      icon: <Icon icon="git-branch-outline" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: `${item.id}-show-workflow`,
      props: {
        onClick: () => handleButtonClick(item, 'show-workflow'),
        disabled: item.status === 'not_signed'
      },
      title: 'Detalle del flujo'
    });
  }

  const createSubMenus = (directoryNode, documentId) => {
    const { id: directoryNodeId } = directoryNode;

    return (
      <div key={`directory-${directoryNode.id}-document-${documentId}`}>
        {directoryNode.hasChildren ? (
          <SubMenu
            title={
              <>
                <span>{directoryNode.name}</span>
                <Icon className="float-right mt-1" height={15} icon="chevron-forward" />
              </>
            }
            onClick={() => handleMoveDocument(directoryNodeId, documentId, parentId)}
          >
            {directoryNode.hasChildren &&
              directoryNode?.children?.map(children => createSubMenus(children, documentId))}
            {!directoryNode.hasChildren && <></>}
          </SubMenu>
        ) : (
          <MenuItem onClick={() => handleMoveDocument(directoryNodeId, documentId, parentId)}>
            {directoryNode.name}
          </MenuItem>
        )}
      </div>
    );
  };

  const renderContent = ({ customComponent = null }) => (
    <>
      <BasicDropdown
        variant="outline-primary"
        noArrow
        center
        titleDrop={
          <span className="align-middle">
            Acciones <Icon icon="ellipsis-vertical" height="10px" width="10px" />
          </span>
        }
        items={dropDownItems}
      >
        {customComponent && customComponent()}
      </BasicDropdown>
    </>
  );

  if (!canMoveFile || !rrhh) {
    return renderContent({});
  }

  return (
    <ContextMenuTrigger id={`contextmenu-document-${item.id}`} ref={contextTrigger} onShow={toggleMenu}>
      {renderContent({
        customComponent: () => (
          <Dropdown.Item onClick={toggleMenu}>
            <Icon icon="share" height="16px" width="16px" style={{ marginRight: 5 }} />
            Mover
          </Dropdown.Item>
        )
      })}
      <ContextMenu id={`contextmenu-document-${item.id}`}>
        {directoryNodes?.map(folder => createSubMenus(folder, item.id))}
      </ContextMenu>
    </ContextMenuTrigger>
  );
};

export default DocumentActionButtons;
